import React, { useEffect, useState } from 'react'
import SupplyOrderBillsTable from './SupplyOrderBillsTable'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { getSupplyBillsByOrderIdAPI } from '../../../../../api/supply/supplyBillAPI'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyOrderBills } from '../../../../../store/supplyOrderSlice'

const SupplyOrderBillList = ({ supplyOrderId }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)
    const dispatch = useDispatch()

    // const [supplyBills, setSupplyBills] = useState([])
    const [isDidRequest, setIsDidRequest] = useState(false) // Чи був вже запит?
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    // useEffect(() => {
    //     if (
    //         supplyOrder && 
    //         supplyOrder.id === supplyOrderId && 
    //         // (!supplyOrder.bills || supplyOrder.bills.length === 0) && 
    //         !isDidRequest
    //     ) {
    //         getSupplyBills()
    //     }
    // }, [supplyOrder, supplyOrderId])

    // const getSupplyBills = () => {
    //     setLoading(true)
    //     setError('')
    //     setIsDidRequest(true)
    //     getSupplyBillsByOrderIdAPI({ supplyOrderId }).then(data => {
    //         // setSupplyBills(data)
    //         dispatch(setSupplyOrderBills(data))
    //         setLoading(false)
    //     }).catch(e => {
    //         setError(responseError(e))
    //         setLoading(false)
    //     })
    // }

  return (
    <div>
        <SupplyOrderBillsTable 
            // supplyOrderBills={supplyBills}
        />
    </div>
  )
}

export default SupplyOrderBillList